import { getTitleThemeColor } from '../../../templates.js';
import { lightenHexColor } from '../../../utils/richText.js';

/** 单行标题组件共用逻辑 */
export const singleTitleMixin = {
	props: {
		data: {
			type: Object,
			required: true,
		},
		editable: {
			type: Boolean,
			default: false,
		},
		active: {
			type: Boolean,
			default: false,
		},
		h5: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['select', 'update'],
	computed: {
		themeColor() {
			return getTitleThemeColor(this.data);
		},
		lightColor() {
			return lightenHexColor(this.themeColor);
		},
	},
	methods: {
		onWrapClick(e) {
			if (!this.editable) return;
			e?.stopPropagation?.();
			this.$emit('select');
		},
		onContentUpdate(content) {
			this.$emit('update', { content });
		},
	},
};

export const HEADING_LEVELS = {
	1: { pc: 32, h5: 0.64 },
	2: { pc: 28, h5: 0.56 },
	3: { pc: 24, h5: 0.48 },
	4: { pc: 20, h5: 0.4 },
	5: { pc: 18, h5: 0.36 },
	6: { pc: 16, h5: 0.32 },
};

export function getHeadingLevel(data) {
	const level = Number(data?.level);
	if (level >= 1 && level <= 6) return level;
	return 1;
}
